import { AccountHistorical } from '../../../../../shared/types/modules/account';

export interface AccountHistoricalProps {
    historical: AccountHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    document: 'Identificación',
    personType: 'Tipo de persona',
    typeDocument: 'Tipo de documento',
    name: 'Nombre / Razón social',
    lastName: 'Apellido',
    gender: 'Género',
    isLGBTIQ: '¿Se identifica como LGBTIQ?',
    cellPhone: 'Celular',
    phone: 'Teléfono',
    email: 'E-mail',
    city: 'Ciudad dirección',
    address: 'Dirección georreferenciación',
    birthdate: 'Fecha de nacimiento',
    hasSpecialCondition: '¿Presenta alguna condición especial?',
    typeContactPerson_specialCondition:
        'Tipo de persona contacto condición especial',
    observations: 'Observaciones',
    isClient: '¿Es cliente?',
    acceptsHabeasData: 'Hábeas data',
    active: '¿Es activa?',
    typeContactPerson: 'Tipo de persona contacto',
};
